import endpoints from "./endpoints";

export default [
  endpoints.assignmentsCount,
  endpoints.assignmentLabels,
  endpoints.notificationMessage,
  endpoints.studentWidgetsDashboardBanner,
  endpoints.notStartedAssignments,
  endpoints.startedAssignments,
  endpoints.studentAssignment,
  endpoints.studentAssignmentComment,
  endpoints.studentAssignmentComments,
  endpoints.studentAssignmentHighlights,
  endpoints.studentAssignmentAssignedElementParts,
  endpoints.actualDistrictAssignments,
  endpoints.districtStudentAssignments,
  endpoints.districtStudentAssignment,
  endpoints.teacherSectionAssignment,
];
